import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationInvitationItem = ResultOf<
  typeof organisationInvitationsQuery
>["organisationInvitations"]["data"][number];

export const organisationInvitationsQuery = graphql(`
  query OrganisationInvitations(
    $organisation_id: ID!
    $first: Int!
    $page: Int
  ) {
    organisationInvitations(
      organisation_id: $organisation_id
      first: $first
      page: $page
    ) {
      data {
        id
        email
        expires_at
        created_at
        invitedBy {
          id
          name
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
